import { ServerDataGrid } from '@cmg/data-grid';
import { styled } from '@cmg/design-system';

import { useStoredGridState } from '../../../../../common/hooks/useStoredGridState';
import { FilteredGridNoRowOverlay } from '../../../../shared/components/filtered-grid-no-row-overlay/FilteredGridNoRowOverlay';
import { ParticipationReportGridContext, ParticipationReportRecord } from './types';
import { useCreateColumnDefs } from './useCreateColumnDefs';
import { useDataSource } from './useDataSource';
import { useGridDataContext } from './useGridDataContext';
import { useSideBarDef } from './useSideBarDef';

const StyledServerDataGrid = styled(
  ServerDataGrid<ParticipationReportRecord, ParticipationReportGridContext>
)`
  margin: ${({ theme }) => `0 ${theme.spacing(2)}`};
  .ag-overlay-wrapper {
    align-items: flex-start;
    margin-top: ${({ theme }) => theme.spacing(3.75)};
  }
`;

export const ParticipationReportDataGrid: React.FC = () => {
  const context = useGridDataContext();
  const columnDefs = useCreateColumnDefs();
  const dataSource = useDataSource();
  const sideBarDef = useSideBarDef();
  const { gridState, handleStateUpdated } = useStoredGridState<
    ParticipationReportRecord,
    ParticipationReportGridContext
  >({
    initialState: {},
    storageKey: 'ParticipationReportGridState',
  });

  return (
    <StyledServerDataGrid
      initialState={gridState}
      onStateUpdated={handleStateUpdated}
      serverSideDatasource={dataSource}
      columnDefs={columnDefs}
      context={context}
      sideBar={sideBarDef}
      cellSelection={true}
      suppressColumnVirtualisation={true}
      noRowsOverlayComponent={FilteredGridNoRowOverlay}
    />
  );
};
